import { observer } from 'mobx-react';
import React from 'react';
import { Checkbox } from 'src/view/components/Controls/Checkbox/Checkbox';
import { IPickerOption } from 'src/view/components/Controls/Pickers/Picker/types';
import TabPicker from 'src/view/components/Controls/Pickers/TabPicker/TabPicker';
import Text from '~/view/components/Text/Text';
import { promocodeDeliveryTypes } from '../../constants/promocodes';
import { promocodeStore } from '../../store/promocodeStore';
import { PROMOCODE_APPLICABILITY, PROMOCODE_DELIVERY_TYPE } from '../../types/promocodes';
import './style.scss';

const deliveryCheckboxes: IPickerOption[] = [
  { value: PROMOCODE_DELIVERY_TYPE.ALL, label: 'all' },
  { value: PROMOCODE_DELIVERY_TYPE.IS_DELIVERY, label: 'Delivery' },
  { value: PROMOCODE_DELIVERY_TYPE.IS_PUCKUP, label: 'Pickup' },
  { value: PROMOCODE_DELIVERY_TYPE.IS_CURBSIDE, label: 'curbside' },
  { value: PROMOCODE_DELIVERY_TYPE.IS_DINEIN, label: 'dine_in' },
];
@observer
export default class PromocodeApplies extends React.Component<{}, {}> {
  changeApplicability = (key: string | number) => {
    promocodeStore.changePromocode({ applicability: key as PROMOCODE_APPLICABILITY });
  };

  changeDeliveryType = (type: string | number) => {
    if (promocodeStore.promocode.delivery_types?.includes(PROMOCODE_DELIVERY_TYPE.ALL)) {
      if (type === PROMOCODE_DELIVERY_TYPE.ALL) return;
      promocodeStore.changePromocode({ delivery_types: promocodeDeliveryTypes.filter((item) => item !== type) });
      return;
    }

    if (type === PROMOCODE_DELIVERY_TYPE.ALL) {
      promocodeStore.changePromocode({ delivery_types: [PROMOCODE_DELIVERY_TYPE.ALL] });
    } else {
      this.deliveryType(type as PROMOCODE_DELIVERY_TYPE);
    }
  };

  deliveryType = (type: PROMOCODE_DELIVERY_TYPE) => {
    if (promocodeStore.promocode.delivery_types?.includes(type)) {
      if (promocodeStore.promocode.delivery_types.length === 1) return;
      promocodeStore.changePromocode({ delivery_types: promocodeStore.promocode.delivery_types.filter((item) => item !== type) });
      return;
    }

    if (promocodeStore.promocode.delivery_types?.length === promocodeDeliveryTypes.length - 1) {
      promocodeStore.changePromocode({ delivery_types: [PROMOCODE_DELIVERY_TYPE.ALL] });
    } else {
      promocodeStore.changePromocode({ delivery_types: promocodeStore.promocode.delivery_types?.concat(type) });
    }
  };

  getDeliveryType = (type: PROMOCODE_DELIVERY_TYPE) => {
    if (promocodeStore.promocode.delivery_types?.includes(PROMOCODE_DELIVERY_TYPE.ALL)) return true;
    if (promocodeStore.promocode.delivery_types?.includes(type)) return true;
    return false;
  };

  get applicabilityOptions(): IPickerOption[] {
    const options = [{ value: PROMOCODE_APPLICABILITY.ORDERS, label: 'regular_orders' }];

    return options;
  }

  get applicabilityStatusValue(): PROMOCODE_APPLICABILITY {
    return promocodeStore.promocode.applicability || PROMOCODE_APPLICABILITY.ORDERS;
  }

  render() {
    return (
      <div className="promocode-applies mt-6">
        <Text type="block-header" text="applies_to" required />
        <div className="d-flex flex-row align-items-center flex-wrap mt-2">
          <TabPicker
            value={this.applicabilityStatusValue}
            options={this.applicabilityOptions}
            onChange={this.changeApplicability}
            className="mr-4 mb-2"
          />

          <div className="d-flex flex-row mb-2 gap-20">
            {deliveryCheckboxes.map((checkbox) => (
              <Checkbox
                key={checkbox.value}
                value={this.getDeliveryType(checkbox.value)}
                name={checkbox.value}
                onClick={this.changeDeliveryType}
                label={checkbox.label}
              />
            ))}
          </div>
        </div>
      </div>
    );
  }
}
